import { useState } from 'react';

export const useSelection = () => {
  const [selectionStart, setSelectionStart] = useState(null);
  const [selectionEnd, setSelectionEnd] = useState(null);
  const [isDraggingSelection, setIsDraggingSelection] = useState(false);

  const isCellSelected = (empId, dateIdx, period, displayDates) => {
    if (!selectionStart || !selectionEnd || !displayDates) return false;
    if (selectionStart.empId !== empId) return false;   // by id, never name
    const s = selectionStart.dateIdx * 2 + (selectionStart.period === 'AM' ? 0 : 1);
    const e = selectionEnd.dateIdx * 2 + (selectionEnd.period === 'AM' ? 0 : 1);
    const c = dateIdx * 2 + (period === 'AM' ? 0 : 1);
    return c >= Math.min(s, e) && c <= Math.max(s, e);
  };

  const clearSelection = () => {
    setSelectionStart(null);
    setSelectionEnd(null);
    setIsDraggingSelection(false);
  };

  return { 
    selectionStart, setSelectionStart, 
    selectionEnd, setSelectionEnd, 
    isDraggingSelection, setIsDraggingSelection, 
    isCellSelected, clearSelection 
  };
};
